import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { InputRegexpDirectiveSharedModule } from '@shared/core/directives/inputRegexp';
import { InputNumbersOnlyDirectiveSharedModule } from '@shared/core/directives/inputNumbersOnly';
import { LetDirectiveSharedModule } from '@shared/core/directives/let';

import { FormsCheckIndicatorModule } from '../formsCheckIndicator';
import { MaterialModule } from '@shared/core/modules/material';
import { ButtonsModule } from '@shared/core/components/buttons';
import { HintsModule } from '@shared/core/components/hints';
import { DropDownModule } from '@shared/core/components/dropDown';

import { FormsInputComponent } from './forms-input.shared.component';

@NgModule({
    declarations: [
        FormsInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        InputRegexpDirectiveSharedModule,
        InputNumbersOnlyDirectiveSharedModule,
        LetDirectiveSharedModule,
        ReactiveFormsModule,
        FormsCheckIndicatorModule,
        HintsModule,
        DropDownModule,
        ButtonsModule,
        MaterialModule,
    ],
    exports: [
        FormsInputComponent
    ],
    providers: [],
})
export class FormsInputModule { }
